export default __webpack_public_path__ + "static/media/ro.b71b00e7.jpg";